export type SupernovaExceptionType =
  | "AccessDenied"
  | "ResourceNotFound"
  | "WrongFormat"
  | "TooMuchWork"
  | "Timeout"
  | "Conflict"
  | "NotImplemented"
  | "BadRequest"
  | "WrongActionOrder"
  | "InvalidOperation"
  | "UnexpectedError"
  | "IPRestricted"
  | "PlanRestricted"
  | "MissingWorkspacePermission"
  | "MissingExporterPermission"
  | "MissingIntegration"
  | "MissingIntegrationAccess"
  | "NoAccess"
  | "MissingCredentials"
  | "ValidationError"
  | "ThirdPartyError";

export class SupernovaException extends Error {
  static wrongFormat(message?: string): SupernovaException {
    return new SupernovaException("WrongFormat", message);
  }

  static validationError(message?: string): SupernovaException {
    return new SupernovaException("ValidationError", message);
  }

  static accessDenied(message?: string): SupernovaException {
    return new SupernovaException("AccessDenied", message);
  }

  static tooMuchWork(message?: string): SupernovaException {
    return new SupernovaException("TooMuchWork", message);
  }

  static notFound(message?: string): SupernovaException {
    return new SupernovaException("ResourceNotFound", message);
  }

  static timeout(message?: string): SupernovaException {
    return new SupernovaException("Timeout", message);
  }

  static conflict(message?: string): SupernovaException {
    return new SupernovaException("Conflict", message);
  }

  static notImplemented(message?: string): SupernovaException {
    return new SupernovaException("NotImplemented", message);
  }

  static wrongActionOrder(message?: string): SupernovaException {
    return new SupernovaException("WrongActionOrder", message);
  }

  static invalidOperation(message?: string): SupernovaException {
    return new SupernovaException("InvalidOperation", message);
  }

  static shouldNotHappen(message?: string): SupernovaException {
    return new SupernovaException("UnexpectedError", message);
  }

  static ipRestricted(message?: string): SupernovaException {
    return new SupernovaException("IPRestricted", message);
  }

  static planRestricted(message?: string): SupernovaException {
    return new SupernovaException("PlanRestricted", message);
  }

  static missingWorkspacePermission(message?: string): SupernovaException {
    return new SupernovaException("MissingWorkspacePermission", message);
  }

  static missingExporterPermission(message?: string): SupernovaException {
    return new SupernovaException("MissingExporterPermission", message);
  }

  static missingIntegration(message?: string): SupernovaException {
    return new SupernovaException("MissingIntegration", message);
  }

  static missingIntegrationAccess(message?: string): SupernovaException {
    return new SupernovaException("MissingIntegrationAccess", message);
  }

  static noAccess(message?: string): SupernovaException {
    return new SupernovaException("NoAccess", message);
  }

  static missingCredentials(message?: string): SupernovaException {
    return new SupernovaException("MissingCredentials", message);
  }

  static thirdPartyError(message?: string): SupernovaException {
    return new SupernovaException("ThirdPartyError", message);
  }

  //
  // To refactor
  //

  static badRequest(message?: string): SupernovaException {
    return new SupernovaException("BadRequest", message);
  }

  //
  // Properties
  //

  constructor(readonly type: SupernovaExceptionType, message?: string) {
    const fullMessage = message || `${type}: something went wrong`;
    super(fullMessage);
  }
}
